module.exports = __webpack_public_path__ + "img/icon_network@2x.5876d488.png";